import PropTypes from 'prop-types';
import { NavLink } from "react-router-dom";
import "layout/Menu/MenuItem.scss";
import { useDialog } from "context/DialogContext";
import LoginExplain from "features/authentication/components/LoginExplain";
import { ReactComponent as IconArrow } from "assets/images/icons/chevron-down.svg";
import { useState } from "react";

function MenuItem({ title, link, icon, disabled, onClick, mobileOnly, subItems }) {
  const { showDialog } = useDialog();
  const [ submenuOpen, setSubmenuOpen] = useState(false);

  const handleSubmenuItemClick = (event) => {
    setSubmenuOpen(value => !value);
    event.preventDefault();
  }

  const handleMenuItemClick = (event) => {
    if (disabled) {
      event.preventDefault();
      showDialog(<LoginExplain/>);
    }

    if (onClick) {
      onClick(event);
    }
  }

  const hasSubitems = subItems?.length > 0;

  const classes = [
    `menu-item`,
    disabled ? `menu-item--disabled` : ``,
    submenuOpen ? `menu-item--open` : ``,
  ];

  return (
    <li className={ classes.join(` `) } data-mobile-only={ mobileOnly }>
      <NavLink to={ link }
               activeClassName={ 'active' }
               onClick={ (event) => hasSubitems ? handleSubmenuItemClick(event) : handleMenuItemClick(event) }
      >
        { icon }
        { title }
        { hasSubitems && <span className={ `submenu-indicator` }><IconArrow/></span> }
      </NavLink>
      {
        hasSubitems && (
          <div className={ `submenu` } onMouseLeave={ () => setSubmenuOpen(false) }>
            <ul className={ `submenu__items` }>
              {
                subItems.map(
                  (subitem, index) => {
                    return (
                      <MenuItem
                        key={ index }
                        title={ subitem.title }
                        link={ subitem.link }
                        onClick={ onClick }
                      />
                    )
                  }
                )
              }
            </ul>
          </div>
        )
      }
    </li>
  );
}

MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  icon: PropTypes.object,
  enabled: PropTypes.bool,
  onClick: PropTypes.func,
  mobileOnly: PropTypes.bool,
  subItems: PropTypes.array,
}

export default MenuItem;
